/// SORT VALUES ///
export const NAME: number = 1;
export const ADDRESS: number = 2;
export const EMAIL: number = 3;
export const DATE: number = 4;
export const NUMBER: number = 5;
